export enum TRANSFER_COMPANY_ACTIONS {
    Move,
    Merge
}

export enum PARTIES {
    Source = "source",
    Target = "target"
}
